"use client";

import Script from "next/script";
import { useCookiebot } from "~lib/tracking/providers/cookiebot-provider";

type Props = {
  hubspotOrgId: string;
};

export function HubspotScript({ hubspotOrgId }: Props) {
  const { consent } = useCookiebot();

  if (!hubspotOrgId || !consent?.statistics) return null;

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      strategy="afterInteractive"
      async
      defer
      data-cookieconsent="statistics"
      src={`//js-eu1.hs-scripts.com/${hubspotOrgId}.js`}
    />
  );
}
